import { MAX_ANNOTATION_LENGTH } from './constants';

/**
 * Validate annotation input length
 *
 * @param value
 * @return undefined | string
 */
export const validateAnnotation = (value: string): undefined | string => {
  if (value?.length > MAX_ANNOTATION_LENGTH)
    return `Maximum length of the annotation: ${MAX_ANNOTATION_LENGTH} chars`;
  return undefined; // undefined return is how InlineEdit validate prop indicates "IS VALID"
};
